/**
 * Set target="_blank" for external links with security attributes
 * Performance: Pre-filtered querySelectorAll to reduce DOM queries
 */
function vzExternalLinksTarget() {
  const domain = window.location.host;

  // Pre-filter to only anchors with href (excludes onclick and empty href)
  const anchors = document.querySelectorAll('a[href]:not([onclick])');

  anchors.forEach(function(anchor) {
    // Early bail: Check if link is external before processing
    // anchor.host will be empty for relative links, making them !== domain
    if (anchor.host && anchor.host !== domain) {
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
    }
  });
}

function vzFocusSearch() {
  const searchOffCanvas = jQuery('#off-canvas-search');
  const searchField = searchOffCanvas.find('input.search-field');
  searchOffCanvas.on('openedEnd.zf.offCanvas', () => {
    searchField.get(0).focus();
  });
}
